module.exports = __webpack_public_path__ + "img/blockeduser.a6d37986.jpg";